import Vue from 'vue';

const manager = new Vue({
  data() {
    return {
      current: null,
    };
  },
});

export default manager;



// WEBPACK FOOTER //
// ./src/components/snackbar/manager.js